import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _get from 'lodash/get';
import AsicModelCard from 'components/asic/AsicModelCard';
import MODELS from 'constants/asicModels';
import gs from 'pages/pages.module.css';
import style from './AsicModels.module.css';

class AsicModels extends Component {
  static propTypes = {
    selectedAsic: PropTypes.string.isRequired,
  }

  renderCards = () => {
    const { selectedAsic } = this.props;
    const foundedAsic = _find(MODELS, model => model.key === selectedAsic) || MODELS[0];

    return _map(_get(foundedAsic, 'models'), (item, i) => (
      <div className={style.cardWrap} key={`${item.title}-${i}`}>
        <AsicModelCard
          {...item}
        />
      </div>
    ));
  }

  render() {
    return (
      <div className={style.wrap}>
        <div className={cx(gs.backgroundHeader, style.backgroundTitle)}>supported</div>
        <div className={style.rootMob}>
          {this.renderCards()}
        </div>
        <div className={style.root}>
          {this.renderCards()}
        </div>
      </div>
    );
  }
}


export default AsicModels;
